module.exports = __webpack_public_path__ + "img/finance.345afe54.gif";